import React, { useEffect, useState } from "react";
import LoginMpinPassWord from "./LoginMpinPassWord";
import SetNewMpin from "./SetNewMpin";
// import VerifyEmailMobile from './VerifyEmailMobile';
import axios from "../../axios";

export default function ForgotMpinOtp({ studentDetails, setRegister, inputSchoolCode, inputValue }) {
  const [emailOtp, setEmailOtp] = useState({
    OtpEnter: null,
    setNewMpin: false,
    backArrow: false,
  });
  const [errorMessage, setErrorMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  // Here increase the forget email otp time
  const [minutes, setMinutes] = useState(2);
  const [seconds, setSeconds] = useState(60);
  const [isClicked, setIsClicked] = useState(false);
  const [isWait, setIsWait] = useState(false);

  useEffect(() => {
    if (isClicked) {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }

        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [seconds, minutes, isClicked]);

  const resendOTP = () => {
    setEmailOtp((prev) => ({ ...prev, OtpEnter: "" }));
    setMinutes(2);
    setSeconds(60);
  };

  function handleOtpChange(e) {
    const value = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    setEmailOtp({ OtpEnter: value });
  }

  const handleValidation = async () => {
    setIsInProgress(true);
    try {
      let res;
      if (selectedOption === "option1") {
        res = await axios.post(`studentAuth/validateMobileOtp`, {
          mobile_number: Number(studentDetails?.mobileNumber),
          mobile_otp: emailOtp?.OtpEnter.toString(),
        });
      } else {
        res = await axios.post(`studentAuth/validateEmailOtp`, {
          unique_id: inputValue,
          school_code: inputSchoolCode,
          otp: emailOtp?.OtpEnter,
        });
      }
      res && setEmailOtp({ emailOtp, setNewMpin: true });
      setIsInProgress(false);
    } catch (error) {
      setErrorMessage(error?.response?.data?.message);
      setIsInProgress(false);
      console.log(error);
    }
  };

  const handleSendOtp = async () => {
    try {
      setIsWait(true)
      setErrorMessage(null);
      setMinutes(2);
      setSeconds(60);
      setIsClicked(true);
      let response = await axios.post(`/studentAuth/generateEmailOtp`,
        {
          unique_id: inputValue,
          school_code: inputSchoolCode
        }
      );
      response && resendOTP();
      setIsWait(false)
    } catch (error) {
      setErrorMessage("Something went wrong!!!");
      console.log(error);
    } finally {
      setIsWait(false)
    }
  };

  const [selectedOption, setSelectedOption] = useState("option2");

  const handleOptionChange = (event) => {
    setEmailOtp((prev) => ({ ...prev, OtpEnter: "" }));
    setIsClicked(false);
    setErrorMessage(null);
    setSelectedOption(event.target.value);
  };

  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== 'string') return email;

      const [localPart, domain] = email.split('@');
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = '*'.repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split('.');
      const maskedDomainMiddle = '*'.repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <spna>{maskEmail(email)}</spna>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };

  return (
    <div>
      {!emailOtp.setNewMpin && !emailOtp.backArrow && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <>
                <div
                  className="backLoginIcon"
                  onClick={(e) => setEmailOtp({ ...emailOtp, backArrow: true })}
                >
                  <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                </div>
                <form>
                  <div className="InsideDetailCpntainer">
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.png"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerEnterOtp mt-3">
                      Welcome Back!
                    </div>
                    <div className="OtpEmailId d-flex justify-content-center mt-1">
                      Forgot PIN
                    </div>

                    <div className="d-flex align-items-center mt-2">
                      {/* Here I commented code for hide the mobile otp option */}
                      {/* <label className="mr-3 d-flex align-items-center">
                        <input
                          className="mr-2"
                          type="radio"
                          value="option1"
                          checked={selectedOption === "option1"}
                          onChange={handleOptionChange}
                        />
                        Mobile
                      </label> */}
                      {/* <label className="d-flex align-items-center">
                        <input
                          className="mr-2 inputRadio"
                          type="radio"
                          value="option2"
                          checked={selectedOption === "option2"}
                          onClick={handleOptionChange}
                        />
                        Email
                      </label> */}
                    </div>
                    {/* <div className="d-flex justify-content-between p-3 align-items-center registrationInput">
                      <input
                        id="otpInput"
                        type="text"
                        value={
                          selectedOption === "option1"
                            ? "+91-" + studentDetails?.mobileNumber
                            : studentDetails?.email
                        }
                      />
                    </div> */}
                    <div
                      className="bg-white border rounded-4 p-4 mt-2 shadow-sm"
                      style={{ borderColor: "#9db3c7" }}
                    >
                      <div className="mb-3">
                        <div className="EmailIdHeader mb-1">Mobile Number</div>

                        <div className="inputBox">
                          <span>+91 {maskPhoneNumber(studentDetails?.mobileNumber)}</span>

                        </div>
                        <span className="text-red-500">{!studentDetails?.mobileNumber && 'Mobile number is not registered!!'}</span>
                      </div>

                      {/* Email */}
                      <div className="mb-3">
                        <div className="EmailIdHeader mb-1">Email ID</div>

                        <div className="inputBox">
                          {MaskedEmail(studentDetails?.email)}

                        </div>
                        <span className="text-red-500">{!studentDetails?.email && 'Email Id is not registered!!'}</span>
                      </div>
                      <div className="d-flex justify-content-between p-3 align-items-center registrationInput  mt-4">
                        <input
                          id="otpInput"
                          type="text"
                          maxLength="6"
                          pattern="[0-9]*"
                          value={emailOtp.OtpEnter}
                          onChange={handleOtpChange}
                          placeholder="Enter OTP"
                          autoComplete="off"
                        />
                        {!isClicked ? (
                          <span
                            className="w-25 ml-5 getOtp"
                            onClick={handleSendOtp}
                          >
                            {isWait ? "Please wait..." : "Get OTP"}
                          </span>
                        ) : (
                          <span className="otp_timer_count">
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </span>
                        )}
                      </div>
                      <div className="d-flex justify-content-between mt-3">
                        <div>
                          {minutes === 0 && seconds === 0 && !errorMessage ? (
                            <div className="invailidOtp ">Time out!</div>
                          ) : (
                            errorMessage === "Invalid OTP." && (
                              <div className="invailidOtp ">
                                invalid OTP entered
                              </div>
                            )
                          )}
                        </div>
                        <div className="d-flex justify-content-end ">
                          <button
                            className="Resend_otp_email"
                            disabled={seconds > 0 || minutes > 0}
                            style={{
                              color:
                                seconds > 0 || minutes > 0
                                  ? "#DFE3E8"
                                  : "#F77F00",
                              borderBottom: seconds > 0 || minutes > 0
                                ? "1px solid #DFE3E8"
                                : "1px solid #F77F00",
                            }}
                            onClick={handleSendOtp}
                          >
                            Resend OTP
                          </button>
                        </div>
                      </div>
                      <div className="d-flex flex-column justify-content-center mt-2">
                        <button
                          type="submit"
                          // I added && minutes === 0 for enable Proceed button
                          disabled={!emailOtp.OtpEnter || isInProgress || seconds === 0 && minutes === 0}
                          onClick={handleValidation}
                          className="RegisterBtn2"
                        >
                          Proceed
                        </button>

                      </div>
                    </div>


                  </div>
                </form>
              </>
            </div>
          </div>
        </div>
      )}

      {emailOtp.backArrow && (
        <LoginMpinPassWord studentDetails={studentDetails} setRegister={setRegister} setIsInProgress={setIsInProgress} />
      )}
      {emailOtp.setNewMpin && (
        <SetNewMpin
          studentDetails={studentDetails}
          setEmailOtp={setEmailOtp}
          setMinutes={setMinutes}
          setSeconds={setSeconds}
          setIsClicked={setIsClicked}
        />
      )}
    </div>
  );
}
